import { useQuery } from '@tanstack/react-query';
import walletService from '../api/walletService';

export const useVendorWallet = () => {
    return useQuery({
        queryKey: ['vendorWallet'],
        queryFn: () => walletService.vendorWallet(),
        staleTime: 5 * 60 * 1000, // cache 5 mins
        refetchInterval: 2 * 60 * 1000 // refresh every 2 mins
    });
};

export const useBanks = () => {
    return useQuery({
        queryKey: ['vendorWallet'],
        queryFn: () => walletService.getBanks(),
        staleTime: 5 * 60 * 1000, // cache 5 mins
        refetchInterval: 2 * 60 * 1000 // refresh every 2 mins
    });
};

export const useVendorWalletTransactions = (filterParams) => {
    return useQuery({
        queryKey: ['vendorWalletTransactions', filterParams],
        queryFn: () => walletService.vendorWalletTransactions(filterParams),
        staleTime: 5 * 60 * 1000, // cache 5 mins
        refetchInterval: 2 * 60 * 1000 // refresh every 2 mins
    });
};
export const useRequestWalletWithdrawal = (amount) => {
    return walletService.requestWalletWithdrawal(amount);
};

export const useSystemWallet = () => {
    return useQuery({
        queryKey: ['systemWallet'],
        queryFn: () => walletService.getSystemWallet(),
        staleTime: 5 * 60 * 1000, // cache 5 mins
        refetchInterval: 2 * 60 * 1000 // refresh every 2 mins
    });
};

export const useMonnifyBalance = () => {
    return useQuery({
        queryKey: ['monnifyBalance'],
        queryFn: () => walletService.getMonnifyBalance(),
        staleTime: 5 * 60 * 1000, // cache 5 mins
        refetchInterval: 2 * 60 * 1000 // refresh every 2 mins
    });
};

export const useVirtualAccount = () => {
    return useQuery({
        queryKey: ['virtualAccount'],
        queryFn: () => walletService.getVirtualAccount(),
        staleTime: 10 * 60 * 1000, // cache 10 mins
        retry: false, // don't hammer the server if the virtual account doesn't exist yet
        throwOnError: false // keep error contained — wallet page shows graceful fallback
    });
};
